import { domClassMerge } from '@propertyfinder/helpers';
import { ModalComponent as BaseModal } from '@propertyfinder/modal';
import { Fragment, FunctionalComponent, h } from 'preact';

import { configGetEnv } from 'common/helper/config/get-env';

import { ModalComponentPropsInterface } from './component-props.interface';
import { ModalIllustrationInterface } from './illustration.interface';

export const ModalComponent: FunctionalComponent<ModalComponentPropsInterface> = ({
  title,
  leftSlot,
  children,
  modalBodyClassName,
  modalContentClassName,
  onClose,
}) => {
  const { description, image } = (leftSlot || {}) as ModalIllustrationInterface;
  const hasIllustration = leftSlot && (description || image);

  return (
    <BaseModal
      openOnLoad
      fullScreen={configGetEnv().platform === 'mobile'}
      bodyClassName={domClassMerge('modal__body', modalBodyClassName)}
      contentClassName={domClassMerge('modal__content', modalContentClassName)}
      title={title}
      onClose={onClose}
      showFooter={false}
    >
      <Fragment>
        {leftSlot && (
          <div className='modal-column__left'>
            {hasIllustration ? (
              <Fragment>
                {image}
                {description && <p className='modal__value-proposition'>{description}</p>}
              </Fragment>
            ) : (
              leftSlot
            )}
          </div>
        )}
        <div
          className={domClassMerge('modal-column__right', {
            ['modal-column__right--fullbleed']: !leftSlot,
          })}
        >
          {children}
        </div>
      </Fragment>
    </BaseModal>
  );
};
